import { getStocks } from '../services/stocksService';
import { getEventDbId } from './eventIdentity';

/**
 * events-v2 sessions yapisi (dizi veya Firestore map) icinden ilk stock/session id.
 */
export const getFirstStockId = (record) => {
  const sessions = record?.sessions;
  if (!sessions) return null;

  if (Array.isArray(sessions)) {
    const first = sessions[0];
    const timeId = first?.times?.[0]?.id;
    if (timeId) return timeId;
    if (typeof first?.id === 'string') return first.id;
    return null;
  }

  if (typeof sessions === 'object') {
    const keys = Object.keys(sessions);
    if (!keys.length) return null;
    const first = sessions[keys[0]];
    return first?.times?.[0]?.id ?? keys[0];
  }

  return null;
};

/**
 * Stock edit linki icin gercek stocks tablosu id'si (API: event'e bagli stock listesi).
 */
export const resolveStockEditId = async (record) => {
  const fromSessions = getFirstStockId(record);
  const eventDbId = getEventDbId(record);
  if (!eventDbId) return fromSessions;

  try {
    const stocks = await getStocks({ eventID: eventDbId, limitCount: 50 });
    if (!stocks?.length) return fromSessions;

    if (fromSessions) {
      const match = stocks.find(
        (s) => s.id === fromSessions || s.stockID === fromSessions,
      );
      if (match) return match.id;
    }

    return stocks[0].id;
  } catch (error) {
    console.error('resolveStockEditId:', error);
    return fromSessions;
  }
};
